module.exports = __webpack_public_path__ + "src/assets/img/dollar.053594c1.svg";